import Input from "core/components/Input"
import { Button } from "core/components/v2/Button"
import StandardSelect from "core/components/v2/StandardSelect"
import { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import LoginPageGradient from "core/components/new/LoginPageGradient"
import LineBottom from "core/components/payment-method/LineBottom"
import LineBottomRot from "assets/svgs/LineBottomRot"
import BosscoderReferLogo from "assets/svgs/BosscoderReferLogo"
import Toast from "core/components/Toast"
import Spinner from "core/components/Spinner"
import BosscoderLogoDoted from "assets/svgs/BosscoderLogoDoted"
import PhoneInput from "react-phone-number-input"
import { CustomScroll } from "react-custom-scroll"
import ProgressMeetFeedbackCard from "./components/ProgressMeetFeedbackCard"
import ProgressMeetFeedbackModal from "./components/ProgressMeetFeedbackModal"
import useProgressMeetFeedbackViewModel from "./ProgressMeetFeedbackViewModel"
import ProgressMeetFeedbackModalExternal from "./components/ProgressMeetFeedbackModalExternal"

const ProgressMeetFeedbackView = () => {
  const { session_id } = useParams()
  const { saveProgressMeetFeedback, toast, changeToastVisibility, openFeedbackModal, setOpenFeedbackModal } =
    useProgressMeetFeedbackViewModel()

  return (
    <div className="flex justify-center items-center min-h-screen ">
      <div className="flex justify-between items-center w-full h-[100vh] bg-[#fff]">
        <div className="relative w-1/3 h-full bg-[#333]">
          <div className="absolute top-[36px] left-[36px]">
            <BosscoderReferLogo />
          </div>
          <div className="absolute top-[20%] -right-[50%] min-[1920px]:-right-[40%]">
            <BosscoderLogoDoted />
          </div>
          <div className="absolute bottom-0">
            <LineBottomRot />
          </div>
          <div className="absolute bottom-0 -left-[80px]">
            <LineBottomRot />
          </div>
        </div>
        <div className="relative overflow-hidden flex justify-center py-[40px] items-center w-2/3 h-full bg-white rounded-[16px]">
          <div className="absolute top-0 right-0">
            <LoginPageGradient className={"#C9E5F5"} />
          </div>

          <div className="absolute top-0 -right-[60px]">
            <LoginPageGradient className={"#C9E5F5"} />
          </div>

          <div className="absolute bottom-0 left-0 scale-y-[-1] scale-x-[-1] w-[42%]">
            <div className="absolute">
              <LoginPageGradient className={"#C9E5F5"} />
            </div>
            <div className="absolute left-[60px]">
              <LoginPageGradient className={"#C9E5F5"} />
            </div>
          </div>
          <CustomScroll heightRelativeToParent="100%" className="rounded-lg no-scrollbar">
            <ProgressMeetFeedbackModalExternal
              isOpen={openFeedbackModal}
              setIsOpen={() => setOpenFeedbackModal(true)}
              chapterName={"Progress Meeting"}
              saveFeedback={saveProgressMeetFeedback}
              meetingId={session_id || ""}
            />
          </CustomScroll>
        </div>
        <Toast data={toast} onClick={() => changeToastVisibility(false)} />
      </div>
    </div>
  )
}

export default ProgressMeetFeedbackView
